import currencyFormatter from 'currency-formatter';
import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {Title} from '../ui/Title';
import styles from './PaymentPending.scss';
import {IOuter} from './PaymentPending.types';

export const PaymentPending: React.FunctionComponent<IOuter> = ({currency, email, price, snapshotId}: IOuter) => {
  const {t} = useTranslation();
  const formattedPrice = currencyFormatter.format(price, {code: currency});

  return (
    <div>
      <Title>{t('mgw.pendingPaymentMessageTitle')}</Title>

      <SmallParagraph className={styles.subtitle} dataHook="paymentMessageSubtitle">
        {t('mgw.pendingPaymentMessageSubtitle', {
          price: formattedPrice,
          email,
        })}
      </SmallParagraph>

      {snapshotId ? (
        <SmallParagraph dataHook="paymentMessageSnapshotId">
          {t('mgw.pendingPaymentMessageSnapshotId', {
            snapshotId,
          })}
        </SmallParagraph>
      ) : null}
    </div>
  );
};

PaymentPending.displayName = 'PaymentPending';
